<template>
<v-container fill-height fluid>
  <v-row align="center" justify="center">
    <v-col md="8">
    <v-card>
      <v-img
        class="white--text align-end"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.4)"
        src="img/korphil_cover.jpg"
        >
        <v-card-title style="word-break: normal">
          <h3>RTC-KorPhil Davao Officially OPENS its FLEXIBLE DELIVERY TRAINING</h3>  
        </v-card-title>
      </v-img>
      <v-card-text>
      <!-- <h2 class="text-center ma-3 mb-0"></h2> -->
      <h4 class="text-center mb-3">(Online and IATF-Based Protocol Face-to-Face Sessions)</h4> 
        <!-- Due to strict adherence to health protocols and to the on-going RE-QUALIFICATION MAP of 2019 
        DIPLOMA programs to the objective of aligning its budgetary requirements with 2020 schemes 
        which include health protocol allocations,  -->
        <!-- <b>the Center is offering momentarily FREE SHORT-TERM programs (TWSP/STEP/ RESP and UAQTEA – Single Qualification SCHOLARSHIPS).</b> -->
        <!-- <br><br> -->

        Aside from Short-Term Courses, <b>DIPLOMA COURSES ARE NOW OPEN AND READY FOR ENROLLMENT AS THE RE-QUALIFICATION MAP HAS BEEN APPROVED. YOU CAN NOW ENROLL IN DIPLOMA COURSES OF YOUR CHOICE)</b>
        <br><br>
        <!-- Please visit our website, www.korphildavao.com and click “PROGRAMS” then “ONLINE PROGRAMS -->
        <ul>
          <li>For fairness, security and proper recording of your training, upon your online enrolment, you have to fill-up correctly asked information in the enrolment form (for short-term courses) and submit important requirements through it.</li>
          <li>Our Registrar Office then checks your submitted information and requirements and will inform you via email the result of your online enrolment application.</li>
          <li>Nevertheless, due to this pandemic we are facing, the online enrolment process will serve just a preliminary step to speed-up the registering procedure, because after this step, you are to be asked to comply some IATF requirements as health protocol to protect not only you, but the Center as a whole – Definitely, there are some Face-to-Face sessions, as you know that TESDA is not only concerned about the knowledge you’ve learned from our online sessions but your SKILLS and ATTITUDE in the workplace.</li>
          <li>TESDA and RTC-KorPhil Davao never cease to extend our services despite this pandemic but we have to do it aptly without compromising your and our health – so please bear with us in this “New Normal”</li>
          <li>Please click each button to know all the details you should know.</li>
        </ul>

        <div class="text-center mt-6">
          <router-link :to="{ name: 'scholarships' }" tag="v-btn">
            <v-btn class="ma-2" color="primary">Available Courses</v-btn>
          </router-link>
          <router-link :to="{ name: 'requirements' }" tag="v-btn">
            <v-btn class="ma-2" color="primary">Online Enrollment</v-btn>
          </router-link>
          <router-link :to="{ name: 'healthProtocol' }" tag="v-btn">
            <v-btn class="ma-2" color="primary">Health Protocol</v-btn>
          </router-link>
        </div>
        
        <br>
        <h4>Note:</h4>
        <ul>
          <li><b>Advance information for the incoming first Year 3-Year DIPLOMA students</b>, aside from the documentary requirements, you have to take an online <b>entrance examination</b>.</li>
          <li>Although you have similar documentary requirements, you have few more to submit.</li>
          <li>When our Provincial Office will advise the resumption of your program, we will announce it to our website and in our Official Facebook account; TESDA XI RTC - KorPhil, Davao.</li>
          <li><b>For the OLD Diploma students</b>, after the Re-Qualification Map you will be informed outright.</li>
        </ul>
        <div class="text-center ma-4">
          <p>Since you already read all the requirements, please click the button below to start your online enrollment.</p>
          <router-link :to="{ name: 'register' } " tag="v-btn">
            <v-btn color="primary">Click Here To Enroll</v-btn>
          </router-link>
        </div>
      </v-card-text>
    </v-card>
    </v-col>
  </v-row>

</v-container>
</template>

<script>

export default {
  name: 'AnnouncementsPage',
}
</script>